import axios from "axios";

// Base URL now comes from .env (REACT_APP_API_BASE_URL) instead of being
// hardcoded — set a different value per environment in .env.development
// and .env.production.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token in the Authorization header
api.interceptors.request.use(
  (config) => {
    // Get the stored user object from sessionStorage
    const storedUser = sessionStorage.getItem("crm_user");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user.token) {
          config.headers.Authorization = `Bearer ${user.token}`;
        }
      } catch (error) {
        console.error("Error parsing stored user:", error);
      }
    }
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

export default api;
